export default function getProductDiscountPercantage(
  price: number | string,
  retailPrice: number | string
) {
  if (price >= retailPrice) return "";

  const percentage = Math.round((+price / +retailPrice) * 100);
  // cap discount between 0 and 100
  const percentageNormalized = Math.min(Math.max(percentage, 100), 0);
  const percentageToString =
    percentageNormalized > 0 ? "%" + percentageNormalized : "";

  return percentageToString;
}
